<!-- TEMPLATE -->
<template>
    <div>
        <v-toolbar class="primary" dense :tabs="drafts.length > 0" dark fixed app>
            <slot name="toolbar-icon"></slot>
            <v-toolbar-title>{{regionName}} - {{$route.params.year}} - {{$route.params.period}}</v-toolbar-title>
            <slot name="toolbar-links"></slot>
            <v-tabs v-show="drafts.length" color="primary" slot="extension" v-model="activeBlock" show-arrows>
                <v-tab v-for="(block, key) in groupedDrafts" :key="tournamentKey + key">
                    <b>{{key}}</b>
                </v-tab>
            </v-tabs>
        </v-toolbar>
        <!-- <v-spacer></v-spacer> -->
        <v-content>
            <v-container>
                <v-layout class="global-loader" v-if="!drafts.length" justify-center>
                    <v-progress-circular :width="3" indeterminate color="primary"></v-progress-circular>
                </v-layout>
                <v-layout justify-center column v-if="drafts.length">
                    <v-tabs-items touchless v-model="activeBlock">
                        <v-tab-item v-for="(block, blockName) in groupedDrafts" :key="tournamentKey + blockName">
                            <v-layout justify-center>
                                <v-flex class="block-container" xs12 lg10>
                                    <v-card>
                                        <v-tabs color="primary" dark>
                                            <v-tab :key="tournamentKey + blockName + 'playersStats'" ripple>
                                                Players Stats
                                            </v-tab>
                                            <v-tab v-if="goldsLines[blockName]" :key="tournamentKey + blockName + 'Golds Difference'" ripple>
                                                Golds Difference
                                            </v-tab>
                                            <v-tabs-items touchless>
                                                <v-tab-item :key="tournamentKey + blockName + 'playersStats'">
                                                    <PlayersStats :players="mapPlayersStats(blockName)" />
                                                </v-tab-item>
                                                <v-tab-item v-if="goldsLines[blockName]" :key="tournamentKey + blockName + 'Golds Difference'">
                                                    <LineChart :lines="getGoldsDiffLines(blockName)" />
                                                </v-tab-item>
                                            </v-tabs-items>
                                        </v-tabs>
                                        <!-- Players Stats -->
                                    </v-card>
                                    <!-- <v-flex class="block-elem" xs12>
                                        <PlayersStats :players="mapPlayersStats(key)" />
                                    </v-flex> -->
                                    <v-flex class="block-title subheading" xs12>
                                        Games
                                    </v-flex>
                                    <v-flex class="block-elem" xs12>
                                        <DraftsList :drafts="block" :title="blockName" />
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs-items>
                </v-layout>
            </v-container>
        </v-content>
    </div>
</template>
<!-- SCRIPT -->
<script>
// import champions from "../../assets/data/champions.json"
// import moment from "moment"
import { map, groupBy } from 'lodash'

import db from '../modules/db'
import DraftsList from './Drafts/DraftsList.vue'
import PlayersStats from './Stats/PlayersStats.vue'
import LineChart from './Charts/LineChart.vue'

const regionsMap = {
    LEC: 'EU',
    NALCS: 'NA',
    LCK: 'LCK',
    WORLDS: 'WORLDS'
}

const regionNames = {
    LEC: 'LEC',
    NALCS: 'LCS',
    LCK: 'LCK',
    WORLDS: 'International'
}

export default {
    name: 'Region',
    components: {
        DraftsList,
        PlayersStats,
        LineChart
    },
    data: function() {
        this.fetchData(this.$route);

        return {
            drafts: [],
            playersStats: {},
            goldsLines: {},
            activeBlock: '',
            tournamentKey: 'InitVal',
            regionName: regionNames[this.$route.params.region]
        }
    },
    methods: {
        fetchData: function(route) {
            let region = 'EU',
                year = 2018,
                period = 'summer';

            if (route.path.length > 1) {
                let params = route.params;

                region = regionsMap[params.region];
                year = params.year;
                period = params.period;
            }

            this.tournamentKey = region + year + period

            // TODO get regions from router.
            Promise.all([
                db.getDrafts(region, year, period),
                db.getPlayersStats(region, year, period),
                db.getGoldsDiff(region, year, period)
            ]).then(vals => {
                this.drafts = vals[0];
                this.playersStats = vals[1];
                this.goldsLines = vals[2] || {};

                this.activeBlock = this.tournamentKey + this.drafts[0].block;
            });
        },
        mapPlayersStats: function(blockKey) {
            let blockStats = this.playersStats[blockKey];

            return map(blockStats, (player, playerName) => {
                player.name = playerName;
                return player;
            });
        },
        getGoldsDiffLines: function(blockName) {
            return _.map(this.goldsLines[blockName].data, (points, teamTag) => {
                return { points: points.slice(4, 26), id: teamTag };
            });
        }
    },
    watch: {
        $route: function(to) {
            this.drafts = [];

            this.regionName = regionNames[this.$route.params.region];

            this.fetchData(to);
        }
    },
    computed: {
        groupedDrafts: function() {
            return groupBy(this.drafts, 'block');
        }
    }
}
</script>
<!-- STYLE -->
<style scoped>
.global-loader {
    min-height: 100vh;
}

img.filter-grey {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

.block-title {
    margin-top: 10px;
    /*margin-bottom: 10px;*/
    color: grey;
}

.block-elem {
    margin-bottom: 10px;
}

.block-container {
    /*margin-top: 10px;*/
}
</style>